import { Controller } from "@hotwired/stimulus"

// Řídí světelný bod putující po trase diagramu procesu.
// - Spustí se, až když je diagram viditelný (přepnutí karty / scroll) → žádná prodleva.
// - Když bod dojede k uzlu, rozsvítí ho (třída is-lit); když odjede, zhasne.
// - Respektuje prefers-reduced-motion (nechá statické).
export default class extends Controller {
  static targets = ["path", "dot", "node"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.duration = 9500 // ms na jednu smyčku
    this.running = false
    this.tick = this.tick.bind(this)

    this.observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => (e.isIntersecting ? this.start() : this.stop())),
      { threshold: 0.12 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.stop()
    this.observer?.disconnect()
  }

  start() {
    if (this.running) return
    // Délku počítáme až tady – trasa je teď určitě vykreslená (viditelná karta).
    this.length = this.pathTarget.getTotalLength()
    if (!this.length) return
    this.running = true
    this.dist = 0
    this.last = null
    this.raf = requestAnimationFrame(this.tick)
  }

  stop() {
    this.running = false
    if (this.raf) cancelAnimationFrame(this.raf)
  }

  tick(now) {
    if (!this.running) return
    if (this.last === null) this.last = now
    this.dist += ((now - this.last) / this.duration) * this.length
    this.last = now
    if (this.dist >= this.length) this.dist -= this.length

    const p = this.pathTarget.getPointAtLength(this.dist)
    this.dotTarget.setAttribute("transform", `translate(${p.x} ${p.y})`)

    // Zeslabení na koncích, aby skok ze závěru na začátek nebyl vidět.
    const f = this.dist / this.length
    const edge = 0.05
    const op = f < edge ? f / edge : f > 1 - edge ? (1 - f) / edge : 1
    this.dotTarget.style.opacity = op

    // Rozsvícení uzlu, u kterého bod právě je (vč. prvního a posledního).
    this.nodeTargets.forEach((node) => {
      const dx = p.x - parseFloat(node.dataset.cx)
      const dy = p.y - parseFloat(node.dataset.cy)
      node.classList.toggle("is-lit", Math.hypot(dx, dy) < 30)
    })

    this.raf = requestAnimationFrame(this.tick)
  }
}
